/* Normalización de los campos de texto del Panel Vencimiento (auditorías de
 * vencimiento).
 *
 * Reglas de operación:
 *  - Nombre del auditor: siempre en mayúsculas.
 *  - Rut QF: si termina en 'k', el dígito verificador se muestra en mayúsculas ('K').
 *
 * Aplica sólo al panel de Vencimiento (title "Panel Vencimiento", datos
 * `auditoria.panel_venc`); el Panel IRD conserva el valor tal como se ingresa.
 */

// null/undefined => '' para que los inputs controlados nunca reciban undefined
const aTexto = (valor)=>{
    return valor === null || valor === undefined ? '' : String(valor)
}

// 'Juan Pérez' => 'JUAN PÉREZ'
export const normalizarNombreAuditor = (valor)=>{
    return aTexto(valor).toUpperCase()
}

// '12345678-k' => '12345678-K' (si no termina en k se devuelve sin cambios)
export const normalizarRutQf = (valor)=>{
    const rut = aTexto(valor)
    return /k$/i.test(rut) ? rut.slice(0, -1) + 'K' : rut
}

// Normaliza el campo que se está editando en el Panel Vencimiento
export const normalizarCampoPanelVenc = (campo, valor)=>{
    if(campo === 'auditor')
        return normalizarNombreAuditor(valor)
    if(campo === 'rut_qf')
        return normalizarRutQf(valor)
    return valor
}

// {auditor, rut_qf, ...} => copia con los campos normalizados (no muta el original)
export const normalizarPanelVenc = (panel)=>{
    if(!panel)
        return panel
    let normalizado = Object.assign({}, panel)
    if(normalizado.auditor !== undefined)
        normalizado.auditor = normalizarNombreAuditor(normalizado.auditor)
    if(normalizado.rut_qf !== undefined)
        normalizado.rut_qf = normalizarRutQf(normalizado.rut_qf)
    return normalizado
}



// WEBPACK FOOTER //
// ./frontEnd/auditorias/revision/panelVencimiento.js